import { css } from "@emotion/react";

export const quickOrderPopup = css`
  width: 100%;
  padding: 0.5rem;
`;

export const container = css``;

export const searchBox = css`
  height: 3.5rem;
  width: 16.75rem;
`;

export const link = css`
  text-decoration: underline;
  text-overflow: ellipsis;
  width: 100%;
`;

export const message = css`
  font-weight: bold;
`;

export const productInfo = css`
  max-width: 16.25rem;
`;
